import { create } from "zustand";
import { persist } from "zustand/middleware";

const useInventoryStore = create(
  persist(
    (set) => ({
      itemCategories: [],
      setItemCategories: (categories) => set({ itemCategories: categories }),

      vendors: [],
      setVendors: (vendors) => set({ vendors }),

      projects: [],
      setProjects: (projects) => set({ projects }),

      lowStockCount: 0,
      setLowStockCount: (count) => set({ lowStockCount: count }),

      pendingRequisitionCount: 0,
      setPendingRequisitionCount: (count) =>
        set({ pendingRequisitionCount: count }),

      clearInventoryStore: () => {
        set({
          itemCategories: [],
          vendors: [],
          projects: [],
          lowStockCount: 0,
          pendingRequisitionCount: 0,
        });
        sessionStorage.removeItem("inventory-storage");
      },
    }),
    {
      name: "inventory-storage",
      storage: {
        getItem: (key) => {
          const value = sessionStorage.getItem(key);
          return value ? JSON.parse(value) : null;
        },
        setItem: (key, value) =>
          sessionStorage.setItem(key, JSON.stringify(value)),
        removeItem: (key) => sessionStorage.removeItem(key),
      },
    }
  )
);

export default useInventoryStore;
